import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AppUpdateService {
  private readonly updates = inject(SwUpdate, { optional: true });

  constructor() {
    if (!this.updates || !this.updates.isEnabled) {
      return;
    }

    this.updates.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => this.doAppUpdate());
  }

  private doAppUpdate() {
    this.updates?.activateUpdate().then(() => document.location.reload());
  }
}
